<template>
    <trax-ui-chart-donut :data="data" :colors="colors">      
    </trax-ui-chart-donut>  
</template>

<script>
    export default {
    
        props: {
            mode: {default: 'completion'},
        },

        data: function() {
            return {
                state: data.state,
                grade_select: data.grade_select,
            }
        },

        computed: {

            data: function() {
                var res = [];
                if (this.state.completion == undefined) {

                    res.push(100);
                
                } else if (this.mode == 'completion') {

                    res.push(this.state.completion.count);
                    res.push(this.state.completion.total -this.state.completion.count );

                } else if (this.mode == 'success') {
                    
                    res.push(this.state.success.passed.count);
                    res.push(this.state.success.partially_passed.count);
                    res.push(this.state.success.failed.count);
                    res.push(this.state.completion.total - this.state.completion.count);

                } else if (this.mode == 'grades') {

                    // Prepare grades count initialized to 0.
                    var grades = {};
                    for (var i = 0; i < this.grade_select.length; i++) {
                        grades[i+1] = 0;
                    }

                    // Count the grades.
                    for (var index in this.state.grades) {
                        grades[this.state.grades[index]]++;
                    }

                    // Add the counts to the res.
                    for (var i = 0; i < this.grade_select.length; i++) {
                        res.push(grades[i+1]);
                    }
                    res.push(this.state.completion.total - this.state.completion.count);
                }
                return res;
            },

            colors: function() {
                var res = [];
                if (this.state.completion == undefined) {

                    res.push(this.rgbColor('default'));     // Grey

                } if (this.mode == 'completion') {

                    res.push(this.rgbColor('success'));     // Success
                    res.push(this.rgbColor('default'));     // Grey

                } else if (this.mode == 'success') {

                    res.push(this.rgbColor('success'));     // Success
                    res.push(this.rgbColor('warning'));     // Warning
                    res.push(this.rgbColor('danger'));      // Danger
                    res.push(this.rgbColor('default'));     // Grey

                } else if (this.mode == 'grades') {

                    for (var index in this.grade_select) {
                        res.push(this.rgbColor(this.grade_select[index].color));
                    }

                }
                return res;
            }
        },

        methods: {

            gradeColor(grade) {
                return this.rgbColor(this.grade_select[grade - 1].color);
            },

            rgbColor(color) {
                return {
                    success: 'rgba(71, 164, 75, 1)',
                    warning: 'rgba(255, 152, 0, 1)',
                    danger: 'rgba(244, 67, 54, 1)',
                    default: 'rgba(0, 0, 0, 0.3)',
                }[color]
            },
        }

    }
</script>
